//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import { required, minLength } from 'vuelidate/lib/validators';

export default BaseCmsBlock.extend({
  name: 'SubscribeBlock',
  data() {
    return {
      errMessages: [],
      isModalOpen: false,
      formData: {
        email: '',
        phone: '',
      },
      isPrivacyPolicy: false,
      mailingAgreement: false,
    };
  },
  watch: {
    formData() {
      this.errMessages = [];
      this.$v.$reset();
    }
  },
  validations: function () {
    let formData = {
      email: {required, minLength: minLength(6)},
      phone: { required, minLength: minLength(15)},
    }
    return { formData }
  },
  methods: {
    async onSubcribe() {
      let form = {};
      this.errMessages = [],
        this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }
      if (this.formData.email.includes('@') && this.formData.phone) {
        form = {
          email: this.formData.email,
          phone: this.formData.phone,
          group_id: '1',
          is_marketing: this.mailingAgreement,
        };
      }
      try {
        let res = await this.$api.agent.transport.post('subscribe', form);
        if (res) {
          this.isModalOpen = true;
          this.$nextTick(() => {
            this.$modal.show('subscribe-modal');
            this.formData = '';
            this.$v.$reset();
          });

          await this.$store.dispatch('mindbox/subscriptionsFooter', {
            group_id: '1',
            email: form?.email,
            phone: form?.phone,
          })
        }
      } catch (error) {
        this.errMessages = [];
        error.response.data.forEach((t) => {
          this.errMessages.push({
            error: t.message,
          });
        });
      }
    },
  },
});
